import { filter, map } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { SymbolLpAction } from '@cbridge-packages/symbol-lp';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';

export const handleSymbolLpNotFoundEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(SymbolLpAction.load.failed),
  filter(({ error }) => error.status === 404),
  map(() => DetailsSidebarAction.close()),
);
